//
// Autogenerated by Thrift Compiler (0.10.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


import Thrift from 'thrift';
import CoreApiExceptions from './core_api_Exceptions_types';
import BarProfitToolExceptions from './bar_profit_tool_Exceptions_types';
import BarProfitToolModel from './bar_profit_tool_Model_types';
import UnauthenticatedUserSessionModel from './unauthenticated_user_session_Model_types';
import UnauthenticatedUserSessionExceptions from './unauthenticated_user_session_Exceptions_types';
import UserInfoExceptions from './user_info_Exceptions_types';

var BarProfitToolService = {};
export default BarProfitToolService;
//HELPER FUNCTIONS AND STRUCTURES

BarProfitToolService.BarProfitToolService_createFirstQuestionSet_args = function(args) {
  this.unauthenticatedUserSessionId = null;
  if (args) {
    if (args.unauthenticatedUserSessionId !== undefined && args.unauthenticatedUserSessionId !== null) {
      this.unauthenticatedUserSessionId = new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId(args.unauthenticatedUserSessionId);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field unauthenticatedUserSessionId is unset!');
    }
  }
};
BarProfitToolService.BarProfitToolService_createFirstQuestionSet_args.prototype = {};
BarProfitToolService.BarProfitToolService_createFirstQuestionSet_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.unauthenticatedUserSessionId = new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId();
        this.unauthenticatedUserSessionId.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_createFirstQuestionSet_args.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_createFirstQuestionSet_args');
  if (this.unauthenticatedUserSessionId !== null && this.unauthenticatedUserSessionId !== undefined) {
    output.writeFieldBegin('unauthenticatedUserSessionId', Thrift.Type.STRUCT, 1);
    this.unauthenticatedUserSessionId.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_createFirstQuestionSet_result = function(args) {
  this.success = null;
  this.unknownUnauthenticatedUserSessionIdException = null;
  this.rateLimitExceededException = null;
  this.serviceTemporarilyUnavailableException = null;
  if (args instanceof UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException) {
    this.unknownUnauthenticatedUserSessionIdException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.RateLimitExceededException) {
    this.rateLimitExceededException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.ServiceTemporarilyUnavailableException) {
    this.serviceTemporarilyUnavailableException = args;
    return;
  }
  if (args) {
    if (args.success !== undefined && args.success !== null) {
      this.success = new BarProfitToolModel.FirstQuestionSetId(args.success);
    }
    if (args.unknownUnauthenticatedUserSessionIdException !== undefined && args.unknownUnauthenticatedUserSessionIdException !== null) {
      this.unknownUnauthenticatedUserSessionIdException = args.unknownUnauthenticatedUserSessionIdException;
    }
    if (args.rateLimitExceededException !== undefined && args.rateLimitExceededException !== null) {
      this.rateLimitExceededException = args.rateLimitExceededException;
    }
    if (args.serviceTemporarilyUnavailableException !== undefined && args.serviceTemporarilyUnavailableException !== null) {
      this.serviceTemporarilyUnavailableException = args.serviceTemporarilyUnavailableException;
    }
  }
};
BarProfitToolService.BarProfitToolService_createFirstQuestionSet_result.prototype = {};
BarProfitToolService.BarProfitToolService_createFirstQuestionSet_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 0:
      if (ftype == Thrift.Type.STRUCT) {
        this.success = new BarProfitToolModel.FirstQuestionSetId();
        this.success.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.unknownUnauthenticatedUserSessionIdException = new UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException();
        this.unknownUnauthenticatedUserSessionIdException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.rateLimitExceededException = new CoreApiExceptions.RateLimitExceededException();
        this.rateLimitExceededException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.serviceTemporarilyUnavailableException = new CoreApiExceptions.ServiceTemporarilyUnavailableException();
        this.serviceTemporarilyUnavailableException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_createFirstQuestionSet_result.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_createFirstQuestionSet_result');
  if (this.success !== null && this.success !== undefined) {
    output.writeFieldBegin('success', Thrift.Type.STRUCT, 0);
    this.success.write(output);
    output.writeFieldEnd();
  }
  if (this.unknownUnauthenticatedUserSessionIdException !== null && this.unknownUnauthenticatedUserSessionIdException !== undefined) {
    output.writeFieldBegin('unknownUnauthenticatedUserSessionIdException', Thrift.Type.STRUCT, 1);
    this.unknownUnauthenticatedUserSessionIdException.write(output);
    output.writeFieldEnd();
  }
  if (this.rateLimitExceededException !== null && this.rateLimitExceededException !== undefined) {
    output.writeFieldBegin('rateLimitExceededException', Thrift.Type.STRUCT, 2);
    this.rateLimitExceededException.write(output);
    output.writeFieldEnd();
  }
  if (this.serviceTemporarilyUnavailableException !== null && this.serviceTemporarilyUnavailableException !== undefined) {
    output.writeFieldBegin('serviceTemporarilyUnavailableException', Thrift.Type.STRUCT, 3);
    this.serviceTemporarilyUnavailableException.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_args = function(args) {
  this.questionSetId = null;
  this.firstName = null;
  this.lastName = null;
  this.zipCode = null;
  this.phoneNumber = null;
  this.emailAddress = null;
  this.barName = null;
  this.barConnection = null;
  if (args) {
    if (args.questionSetId !== undefined && args.questionSetId !== null) {
      this.questionSetId = new BarProfitToolModel.FirstQuestionSetId(args.questionSetId);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field questionSetId is unset!');
    }
    if (args.firstName !== undefined && args.firstName !== null) {
      this.firstName = args.firstName;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field firstName is unset!');
    }
    if (args.lastName !== undefined && args.lastName !== null) {
      this.lastName = args.lastName;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field lastName is unset!');
    }
    if (args.zipCode !== undefined && args.zipCode !== null) {
      this.zipCode = args.zipCode;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field zipCode is unset!');
    }
    if (args.phoneNumber !== undefined && args.phoneNumber !== null) {
      this.phoneNumber = args.phoneNumber;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field phoneNumber is unset!');
    }
    if (args.emailAddress !== undefined && args.emailAddress !== null) {
      this.emailAddress = args.emailAddress;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field emailAddress is unset!');
    }
    if (args.barName !== undefined && args.barName !== null) {
      this.barName = args.barName;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field barName is unset!');
    }
    if (args.barConnection !== undefined && args.barConnection !== null) {
      this.barConnection = args.barConnection;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field barConnection is unset!');
    }
  }
};
BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_args.prototype = {};
BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.questionSetId = new BarProfitToolModel.FirstQuestionSetId();
        this.questionSetId.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRING) {
        this.firstName = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRING) {
        this.lastName = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRING) {
        this.zipCode = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 5:
      if (ftype == Thrift.Type.STRING) {
        this.phoneNumber = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 6:
      if (ftype == Thrift.Type.STRING) {
        this.emailAddress = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 7:
      if (ftype == Thrift.Type.STRING) {
        this.barName = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 8:
      if (ftype == Thrift.Type.STRING) {
        this.barConnection = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_args.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_answerFirstQuestionSet_args');
  if (this.questionSetId !== null && this.questionSetId !== undefined) {
    output.writeFieldBegin('questionSetId', Thrift.Type.STRUCT, 1);
    this.questionSetId.write(output);
    output.writeFieldEnd();
  }
  if (this.firstName !== null && this.firstName !== undefined) {
    output.writeFieldBegin('firstName', Thrift.Type.STRING, 2);
    output.writeString(this.firstName);
    output.writeFieldEnd();
  }
  if (this.lastName !== null && this.lastName !== undefined) {
    output.writeFieldBegin('lastName', Thrift.Type.STRING, 3);
    output.writeString(this.lastName);
    output.writeFieldEnd();
  }
  if (this.zipCode !== null && this.zipCode !== undefined) {
    output.writeFieldBegin('zipCode', Thrift.Type.STRING, 4);
    output.writeString(this.zipCode);
    output.writeFieldEnd();
  }
  if (this.phoneNumber !== null && this.phoneNumber !== undefined) {
    output.writeFieldBegin('phoneNumber', Thrift.Type.STRING, 5);
    output.writeString(this.phoneNumber);
    output.writeFieldEnd();
  }
  if (this.emailAddress !== null && this.emailAddress !== undefined) {
    output.writeFieldBegin('emailAddress', Thrift.Type.STRING, 6);
    output.writeString(this.emailAddress);
    output.writeFieldEnd();
  }
  if (this.barName !== null && this.barName !== undefined) {
    output.writeFieldBegin('barName', Thrift.Type.STRING, 7);
    output.writeString(this.barName);
    output.writeFieldEnd();
  }
  if (this.barConnection !== null && this.barConnection !== undefined) {
    output.writeFieldBegin('barConnection', Thrift.Type.STRING, 8);
    output.writeString(this.barConnection);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_result = function(args) {
  this.questionSetAlreadyAnsweredException = null;
  this.unknownQuestionSetException = null;
  this.firstNameInvalidStringLengthException = null;
  this.lastNameInvalidStringLengthException = null;
  this.zipCodeInvalidStringLengthException = null;
  this.phoneNumberInvalidStringLengthException = null;
  this.emailAddressInvalidStringLengthException = null;
  this.barNameInvalidStringLengthException = null;
  this.barConnectionInvalidStringLengthException = null;
  this.rateLimitExceededException = null;
  this.serviceTemporarilyUnavailableException = null;
  if (args instanceof BarProfitToolExceptions.QuestionSetAlreadyAnsweredException) {
    this.questionSetAlreadyAnsweredException = args;
    return;
  }
  if (args instanceof BarProfitToolExceptions.UnknownQuestionSetException) {
    this.unknownQuestionSetException = args;
    return;
  }
  if (args instanceof UserInfoExceptions.FirstNameInvalidStringLengthException) {
    this.firstNameInvalidStringLengthException = args;
    return;
  }
  if (args instanceof UserInfoExceptions.LastNameInvalidStringLengthException) {
    this.lastNameInvalidStringLengthException = args;
    return;
  }
  if (args instanceof UserInfoExceptions.ZipCodeInvalidStringLengthException) {
    this.zipCodeInvalidStringLengthException = args;
    return;
  }
  if (args instanceof UserInfoExceptions.PhoneNumberInvalidStringLengthException) {
    this.phoneNumberInvalidStringLengthException = args;
    return;
  }
  if (args instanceof UserInfoExceptions.EmailAddressInvalidStringLengthException) {
    this.emailAddressInvalidStringLengthException = args;
    return;
  }
  if (args instanceof UserInfoExceptions.BarNameInvalidStringLengthException) {
    this.barNameInvalidStringLengthException = args;
    return;
  }
  if (args instanceof UserInfoExceptions.BarConnectionInvalidStringLengthException) {
    this.barConnectionInvalidStringLengthException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.RateLimitExceededException) {
    this.rateLimitExceededException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.ServiceTemporarilyUnavailableException) {
    this.serviceTemporarilyUnavailableException = args;
    return;
  }
  if (args) {
    if (args.questionSetAlreadyAnsweredException !== undefined && args.questionSetAlreadyAnsweredException !== null) {
      this.questionSetAlreadyAnsweredException = args.questionSetAlreadyAnsweredException;
    }
    if (args.unknownQuestionSetException !== undefined && args.unknownQuestionSetException !== null) {
      this.unknownQuestionSetException = args.unknownQuestionSetException;
    }
    if (args.firstNameInvalidStringLengthException !== undefined && args.firstNameInvalidStringLengthException !== null) {
      this.firstNameInvalidStringLengthException = args.firstNameInvalidStringLengthException;
    }
    if (args.lastNameInvalidStringLengthException !== undefined && args.lastNameInvalidStringLengthException !== null) {
      this.lastNameInvalidStringLengthException = args.lastNameInvalidStringLengthException;
    }
    if (args.zipCodeInvalidStringLengthException !== undefined && args.zipCodeInvalidStringLengthException !== null) {
      this.zipCodeInvalidStringLengthException = args.zipCodeInvalidStringLengthException;
    }
    if (args.phoneNumberInvalidStringLengthException !== undefined && args.phoneNumberInvalidStringLengthException !== null) {
      this.phoneNumberInvalidStringLengthException = args.phoneNumberInvalidStringLengthException;
    }
    if (args.emailAddressInvalidStringLengthException !== undefined && args.emailAddressInvalidStringLengthException !== null) {
      this.emailAddressInvalidStringLengthException = args.emailAddressInvalidStringLengthException;
    }
    if (args.barNameInvalidStringLengthException !== undefined && args.barNameInvalidStringLengthException !== null) {
      this.barNameInvalidStringLengthException = args.barNameInvalidStringLengthException;
    }
    if (args.barConnectionInvalidStringLengthException !== undefined && args.barConnectionInvalidStringLengthException !== null) {
      this.barConnectionInvalidStringLengthException = args.barConnectionInvalidStringLengthException;
    }
    if (args.rateLimitExceededException !== undefined && args.rateLimitExceededException !== null) {
      this.rateLimitExceededException = args.rateLimitExceededException;
    }
    if (args.serviceTemporarilyUnavailableException !== undefined && args.serviceTemporarilyUnavailableException !== null) {
      this.serviceTemporarilyUnavailableException = args.serviceTemporarilyUnavailableException;
    }
  }
};
BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_result.prototype = {};
BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.questionSetAlreadyAnsweredException = new BarProfitToolExceptions.QuestionSetAlreadyAnsweredException();
        this.questionSetAlreadyAnsweredException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.unknownQuestionSetException = new BarProfitToolExceptions.UnknownQuestionSetException();
        this.unknownQuestionSetException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.firstNameInvalidStringLengthException = new UserInfoExceptions.FirstNameInvalidStringLengthException();
        this.firstNameInvalidStringLengthException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.lastNameInvalidStringLengthException = new UserInfoExceptions.LastNameInvalidStringLengthException();
        this.lastNameInvalidStringLengthException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 5:
      if (ftype == Thrift.Type.STRUCT) {
        this.zipCodeInvalidStringLengthException = new UserInfoExceptions.ZipCodeInvalidStringLengthException();
        this.zipCodeInvalidStringLengthException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 6:
      if (ftype == Thrift.Type.STRUCT) {
        this.phoneNumberInvalidStringLengthException = new UserInfoExceptions.PhoneNumberInvalidStringLengthException();
        this.phoneNumberInvalidStringLengthException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 7:
      if (ftype == Thrift.Type.STRUCT) {
        this.emailAddressInvalidStringLengthException = new UserInfoExceptions.EmailAddressInvalidStringLengthException();
        this.emailAddressInvalidStringLengthException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 8:
      if (ftype == Thrift.Type.STRUCT) {
        this.barNameInvalidStringLengthException = new UserInfoExceptions.BarNameInvalidStringLengthException();
        this.barNameInvalidStringLengthException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 9:
      if (ftype == Thrift.Type.STRUCT) {
        this.barConnectionInvalidStringLengthException = new UserInfoExceptions.BarConnectionInvalidStringLengthException();
        this.barConnectionInvalidStringLengthException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 10:
      if (ftype == Thrift.Type.STRUCT) {
        this.rateLimitExceededException = new CoreApiExceptions.RateLimitExceededException();
        this.rateLimitExceededException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 11:
      if (ftype == Thrift.Type.STRUCT) {
        this.serviceTemporarilyUnavailableException = new CoreApiExceptions.ServiceTemporarilyUnavailableException();
        this.serviceTemporarilyUnavailableException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_result.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_answerFirstQuestionSet_result');
  if (this.questionSetAlreadyAnsweredException !== null && this.questionSetAlreadyAnsweredException !== undefined) {
    output.writeFieldBegin('questionSetAlreadyAnsweredException', Thrift.Type.STRUCT, 1);
    this.questionSetAlreadyAnsweredException.write(output);
    output.writeFieldEnd();
  }
  if (this.unknownQuestionSetException !== null && this.unknownQuestionSetException !== undefined) {
    output.writeFieldBegin('unknownQuestionSetException', Thrift.Type.STRUCT, 2);
    this.unknownQuestionSetException.write(output);
    output.writeFieldEnd();
  }
  if (this.firstNameInvalidStringLengthException !== null && this.firstNameInvalidStringLengthException !== undefined) {
    output.writeFieldBegin('firstNameInvalidStringLengthException', Thrift.Type.STRUCT, 3);
    this.firstNameInvalidStringLengthException.write(output);
    output.writeFieldEnd();
  }
  if (this.lastNameInvalidStringLengthException !== null && this.lastNameInvalidStringLengthException !== undefined) {
    output.writeFieldBegin('lastNameInvalidStringLengthException', Thrift.Type.STRUCT, 4);
    this.lastNameInvalidStringLengthException.write(output);
    output.writeFieldEnd();
  }
  if (this.zipCodeInvalidStringLengthException !== null && this.zipCodeInvalidStringLengthException !== undefined) {
    output.writeFieldBegin('zipCodeInvalidStringLengthException', Thrift.Type.STRUCT, 5);
    this.zipCodeInvalidStringLengthException.write(output);
    output.writeFieldEnd();
  }
  if (this.phoneNumberInvalidStringLengthException !== null && this.phoneNumberInvalidStringLengthException !== undefined) {
    output.writeFieldBegin('phoneNumberInvalidStringLengthException', Thrift.Type.STRUCT, 6);
    this.phoneNumberInvalidStringLengthException.write(output);
    output.writeFieldEnd();
  }
  if (this.emailAddressInvalidStringLengthException !== null && this.emailAddressInvalidStringLengthException !== undefined) {
    output.writeFieldBegin('emailAddressInvalidStringLengthException', Thrift.Type.STRUCT, 7);
    this.emailAddressInvalidStringLengthException.write(output);
    output.writeFieldEnd();
  }
  if (this.barNameInvalidStringLengthException !== null && this.barNameInvalidStringLengthException !== undefined) {
    output.writeFieldBegin('barNameInvalidStringLengthException', Thrift.Type.STRUCT, 8);
    this.barNameInvalidStringLengthException.write(output);
    output.writeFieldEnd();
  }
  if (this.barConnectionInvalidStringLengthException !== null && this.barConnectionInvalidStringLengthException !== undefined) {
    output.writeFieldBegin('barConnectionInvalidStringLengthException', Thrift.Type.STRUCT, 9);
    this.barConnectionInvalidStringLengthException.write(output);
    output.writeFieldEnd();
  }
  if (this.rateLimitExceededException !== null && this.rateLimitExceededException !== undefined) {
    output.writeFieldBegin('rateLimitExceededException', Thrift.Type.STRUCT, 10);
    this.rateLimitExceededException.write(output);
    output.writeFieldEnd();
  }
  if (this.serviceTemporarilyUnavailableException !== null && this.serviceTemporarilyUnavailableException !== undefined) {
    output.writeFieldBegin('serviceTemporarilyUnavailableException', Thrift.Type.STRUCT, 11);
    this.serviceTemporarilyUnavailableException.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_createSecondQuestionSet_args = function(args) {
  this.unauthenticatedUserSessionId = null;
  if (args) {
    if (args.unauthenticatedUserSessionId !== undefined && args.unauthenticatedUserSessionId !== null) {
      this.unauthenticatedUserSessionId = new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId(args.unauthenticatedUserSessionId);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field unauthenticatedUserSessionId is unset!');
    }
  }
};
BarProfitToolService.BarProfitToolService_createSecondQuestionSet_args.prototype = {};
BarProfitToolService.BarProfitToolService_createSecondQuestionSet_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.unauthenticatedUserSessionId = new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId();
        this.unauthenticatedUserSessionId.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_createSecondQuestionSet_args.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_createSecondQuestionSet_args');
  if (this.unauthenticatedUserSessionId !== null && this.unauthenticatedUserSessionId !== undefined) {
    output.writeFieldBegin('unauthenticatedUserSessionId', Thrift.Type.STRUCT, 1);
    this.unauthenticatedUserSessionId.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_createSecondQuestionSet_result = function(args) {
  this.success = null;
  this.firstQuestionSetNotAnsweredException = null;
  this.unknownUnauthenticatedUserSessionIdException = null;
  this.rateLimitExceededException = null;
  this.serviceTemporarilyUnavailableException = null;
  if (args instanceof BarProfitToolExceptions.FirstQuestionSetNotAnsweredException) {
    this.firstQuestionSetNotAnsweredException = args;
    return;
  }
  if (args instanceof UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException) {
    this.unknownUnauthenticatedUserSessionIdException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.RateLimitExceededException) {
    this.rateLimitExceededException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.ServiceTemporarilyUnavailableException) {
    this.serviceTemporarilyUnavailableException = args;
    return;
  }
  if (args) {
    if (args.success !== undefined && args.success !== null) {
      this.success = new BarProfitToolModel.SecondQuestionSetId(args.success);
    }
    if (args.firstQuestionSetNotAnsweredException !== undefined && args.firstQuestionSetNotAnsweredException !== null) {
      this.firstQuestionSetNotAnsweredException = args.firstQuestionSetNotAnsweredException;
    }
    if (args.unknownUnauthenticatedUserSessionIdException !== undefined && args.unknownUnauthenticatedUserSessionIdException !== null) {
      this.unknownUnauthenticatedUserSessionIdException = args.unknownUnauthenticatedUserSessionIdException;
    }
    if (args.rateLimitExceededException !== undefined && args.rateLimitExceededException !== null) {
      this.rateLimitExceededException = args.rateLimitExceededException;
    }
    if (args.serviceTemporarilyUnavailableException !== undefined && args.serviceTemporarilyUnavailableException !== null) {
      this.serviceTemporarilyUnavailableException = args.serviceTemporarilyUnavailableException;
    }
  }
};
BarProfitToolService.BarProfitToolService_createSecondQuestionSet_result.prototype = {};
BarProfitToolService.BarProfitToolService_createSecondQuestionSet_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 0:
      if (ftype == Thrift.Type.STRUCT) {
        this.success = new BarProfitToolModel.SecondQuestionSetId();
        this.success.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.firstQuestionSetNotAnsweredException = new BarProfitToolExceptions.FirstQuestionSetNotAnsweredException();
        this.firstQuestionSetNotAnsweredException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.unknownUnauthenticatedUserSessionIdException = new UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException();
        this.unknownUnauthenticatedUserSessionIdException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.rateLimitExceededException = new CoreApiExceptions.RateLimitExceededException();
        this.rateLimitExceededException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.serviceTemporarilyUnavailableException = new CoreApiExceptions.ServiceTemporarilyUnavailableException();
        this.serviceTemporarilyUnavailableException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_createSecondQuestionSet_result.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_createSecondQuestionSet_result');
  if (this.success !== null && this.success !== undefined) {
    output.writeFieldBegin('success', Thrift.Type.STRUCT, 0);
    this.success.write(output);
    output.writeFieldEnd();
  }
  if (this.firstQuestionSetNotAnsweredException !== null && this.firstQuestionSetNotAnsweredException !== undefined) {
    output.writeFieldBegin('firstQuestionSetNotAnsweredException', Thrift.Type.STRUCT, 1);
    this.firstQuestionSetNotAnsweredException.write(output);
    output.writeFieldEnd();
  }
  if (this.unknownUnauthenticatedUserSessionIdException !== null && this.unknownUnauthenticatedUserSessionIdException !== undefined) {
    output.writeFieldBegin('unknownUnauthenticatedUserSessionIdException', Thrift.Type.STRUCT, 2);
    this.unknownUnauthenticatedUserSessionIdException.write(output);
    output.writeFieldEnd();
  }
  if (this.rateLimitExceededException !== null && this.rateLimitExceededException !== undefined) {
    output.writeFieldBegin('rateLimitExceededException', Thrift.Type.STRUCT, 3);
    this.rateLimitExceededException.write(output);
    output.writeFieldEnd();
  }
  if (this.serviceTemporarilyUnavailableException !== null && this.serviceTemporarilyUnavailableException !== undefined) {
    output.writeFieldBegin('serviceTemporarilyUnavailableException', Thrift.Type.STRUCT, 4);
    this.serviceTemporarilyUnavailableException.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_args = function(args) {
  this.questionSetId = null;
  this.barProfitToolFormData = null;
  if (args) {
    if (args.questionSetId !== undefined && args.questionSetId !== null) {
      this.questionSetId = new BarProfitToolModel.SecondQuestionSetId(args.questionSetId);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field questionSetId is unset!');
    }
    if (args.barProfitToolFormData !== undefined && args.barProfitToolFormData !== null) {
      this.barProfitToolFormData = new BarProfitToolModel.SecondAnswerSet(args.barProfitToolFormData);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field barProfitToolFormData is unset!');
    }
  }
};
BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_args.prototype = {};
BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.questionSetId = new BarProfitToolModel.SecondQuestionSetId();
        this.questionSetId.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.barProfitToolFormData = new BarProfitToolModel.SecondAnswerSet();
        this.barProfitToolFormData.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_args.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_answerSecondQuestionSet_args');
  if (this.questionSetId !== null && this.questionSetId !== undefined) {
    output.writeFieldBegin('questionSetId', Thrift.Type.STRUCT, 1);
    this.questionSetId.write(output);
    output.writeFieldEnd();
  }
  if (this.barProfitToolFormData !== null && this.barProfitToolFormData !== undefined) {
    output.writeFieldBegin('barProfitToolFormData', Thrift.Type.STRUCT, 2);
    this.barProfitToolFormData.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_result = function(args) {
  this.success = null;
  this.questionSetAlreadyAnsweredException = null;
  this.unknownQuestionSetException = null;
  this.invalidProductCategoryAndOrTotalValueException = null;
  this.rateLimitExceededException = null;
  this.serviceTemporarilyUnavailableException = null;
  if (args instanceof BarProfitToolExceptions.QuestionSetAlreadyAnsweredException) {
    this.questionSetAlreadyAnsweredException = args;
    return;
  }
  if (args instanceof BarProfitToolExceptions.UnknownQuestionSetException) {
    this.unknownQuestionSetException = args;
    return;
  }
  if (args instanceof BarProfitToolExceptions.InvalidProductCategoryAndOrTotalValueException) {
    this.invalidProductCategoryAndOrTotalValueException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.RateLimitExceededException) {
    this.rateLimitExceededException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.ServiceTemporarilyUnavailableException) {
    this.serviceTemporarilyUnavailableException = args;
    return;
  }
  if (args) {
    if (args.success !== undefined && args.success !== null) {
      this.success = new BarProfitToolModel.SecondAnswerSetId(args.success);
    }
    if (args.questionSetAlreadyAnsweredException !== undefined && args.questionSetAlreadyAnsweredException !== null) {
      this.questionSetAlreadyAnsweredException = args.questionSetAlreadyAnsweredException;
    }
    if (args.unknownQuestionSetException !== undefined && args.unknownQuestionSetException !== null) {
      this.unknownQuestionSetException = args.unknownQuestionSetException;
    }
    if (args.invalidProductCategoryAndOrTotalValueException !== undefined && args.invalidProductCategoryAndOrTotalValueException !== null) {
      this.invalidProductCategoryAndOrTotalValueException = args.invalidProductCategoryAndOrTotalValueException;
    }
    if (args.rateLimitExceededException !== undefined && args.rateLimitExceededException !== null) {
      this.rateLimitExceededException = args.rateLimitExceededException;
    }
    if (args.serviceTemporarilyUnavailableException !== undefined && args.serviceTemporarilyUnavailableException !== null) {
      this.serviceTemporarilyUnavailableException = args.serviceTemporarilyUnavailableException;
    }
  }
};
BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_result.prototype = {};
BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 0:
      if (ftype == Thrift.Type.STRUCT) {
        this.success = new BarProfitToolModel.SecondAnswerSetId();
        this.success.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.questionSetAlreadyAnsweredException = new BarProfitToolExceptions.QuestionSetAlreadyAnsweredException();
        this.questionSetAlreadyAnsweredException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.unknownQuestionSetException = new BarProfitToolExceptions.UnknownQuestionSetException();
        this.unknownQuestionSetException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.invalidProductCategoryAndOrTotalValueException = new BarProfitToolExceptions.InvalidProductCategoryAndOrTotalValueException();
        this.invalidProductCategoryAndOrTotalValueException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.rateLimitExceededException = new CoreApiExceptions.RateLimitExceededException();
        this.rateLimitExceededException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 5:
      if (ftype == Thrift.Type.STRUCT) {
        this.serviceTemporarilyUnavailableException = new CoreApiExceptions.ServiceTemporarilyUnavailableException();
        this.serviceTemporarilyUnavailableException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_result.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_answerSecondQuestionSet_result');
  if (this.success !== null && this.success !== undefined) {
    output.writeFieldBegin('success', Thrift.Type.STRUCT, 0);
    this.success.write(output);
    output.writeFieldEnd();
  }
  if (this.questionSetAlreadyAnsweredException !== null && this.questionSetAlreadyAnsweredException !== undefined) {
    output.writeFieldBegin('questionSetAlreadyAnsweredException', Thrift.Type.STRUCT, 1);
    this.questionSetAlreadyAnsweredException.write(output);
    output.writeFieldEnd();
  }
  if (this.unknownQuestionSetException !== null && this.unknownQuestionSetException !== undefined) {
    output.writeFieldBegin('unknownQuestionSetException', Thrift.Type.STRUCT, 2);
    this.unknownQuestionSetException.write(output);
    output.writeFieldEnd();
  }
  if (this.invalidProductCategoryAndOrTotalValueException !== null && this.invalidProductCategoryAndOrTotalValueException !== undefined) {
    output.writeFieldBegin('invalidProductCategoryAndOrTotalValueException', Thrift.Type.STRUCT, 3);
    this.invalidProductCategoryAndOrTotalValueException.write(output);
    output.writeFieldEnd();
  }
  if (this.rateLimitExceededException !== null && this.rateLimitExceededException !== undefined) {
    output.writeFieldBegin('rateLimitExceededException', Thrift.Type.STRUCT, 4);
    this.rateLimitExceededException.write(output);
    output.writeFieldEnd();
  }
  if (this.serviceTemporarilyUnavailableException !== null && this.serviceTemporarilyUnavailableException !== undefined) {
    output.writeFieldBegin('serviceTemporarilyUnavailableException', Thrift.Type.STRUCT, 5);
    this.serviceTemporarilyUnavailableException.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_getReport_args = function(args) {
  this.unauthenticatedUserSessionId = null;
  this.secondAnswerSetId = null;
  if (args) {
    if (args.unauthenticatedUserSessionId !== undefined && args.unauthenticatedUserSessionId !== null) {
      this.unauthenticatedUserSessionId = new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId(args.unauthenticatedUserSessionId);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field unauthenticatedUserSessionId is unset!');
    }
    if (args.secondAnswerSetId !== undefined && args.secondAnswerSetId !== null) {
      this.secondAnswerSetId = new BarProfitToolModel.SecondAnswerSetId(args.secondAnswerSetId);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field secondAnswerSetId is unset!');
    }
  }
};
BarProfitToolService.BarProfitToolService_getReport_args.prototype = {};
BarProfitToolService.BarProfitToolService_getReport_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.unauthenticatedUserSessionId = new UnauthenticatedUserSessionModel.UnauthenticatedUserSessionId();
        this.unauthenticatedUserSessionId.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.secondAnswerSetId = new BarProfitToolModel.SecondAnswerSetId();
        this.secondAnswerSetId.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_getReport_args.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_getReport_args');
  if (this.unauthenticatedUserSessionId !== null && this.unauthenticatedUserSessionId !== undefined) {
    output.writeFieldBegin('unauthenticatedUserSessionId', Thrift.Type.STRUCT, 1);
    this.unauthenticatedUserSessionId.write(output);
    output.writeFieldEnd();
  }
  if (this.secondAnswerSetId !== null && this.secondAnswerSetId !== undefined) {
    output.writeFieldBegin('secondAnswerSetId', Thrift.Type.STRUCT, 2);
    this.secondAnswerSetId.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_getReport_result = function(args) {
  this.success = null;
  this.unknownAnswerSetIdException = null;
  this.unknownUnauthenticatedUserSessionIdException = null;
  this.rateLimitExceededException = null;
  this.serviceTemporarilyUnavailableException = null;
  if (args instanceof BarProfitToolExceptions.UnknownAnswerSetIdException) {
    this.unknownAnswerSetIdException = args;
    return;
  }
  if (args instanceof UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException) {
    this.unknownUnauthenticatedUserSessionIdException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.RateLimitExceededException) {
    this.rateLimitExceededException = args;
    return;
  }
  if (args instanceof CoreApiExceptions.ServiceTemporarilyUnavailableException) {
    this.serviceTemporarilyUnavailableException = args;
    return;
  }
  if (args) {
    if (args.success !== undefined && args.success !== null) {
      this.success = new BarProfitToolModel.Report(args.success);
    }
    if (args.unknownAnswerSetIdException !== undefined && args.unknownAnswerSetIdException !== null) {
      this.unknownAnswerSetIdException = args.unknownAnswerSetIdException;
    }
    if (args.unknownUnauthenticatedUserSessionIdException !== undefined && args.unknownUnauthenticatedUserSessionIdException !== null) {
      this.unknownUnauthenticatedUserSessionIdException = args.unknownUnauthenticatedUserSessionIdException;
    }
    if (args.rateLimitExceededException !== undefined && args.rateLimitExceededException !== null) {
      this.rateLimitExceededException = args.rateLimitExceededException;
    }
    if (args.serviceTemporarilyUnavailableException !== undefined && args.serviceTemporarilyUnavailableException !== null) {
      this.serviceTemporarilyUnavailableException = args.serviceTemporarilyUnavailableException;
    }
  }
};
BarProfitToolService.BarProfitToolService_getReport_result.prototype = {};
BarProfitToolService.BarProfitToolService_getReport_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 0:
      if (ftype == Thrift.Type.STRUCT) {
        this.success = new BarProfitToolModel.Report();
        this.success.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.unknownAnswerSetIdException = new BarProfitToolExceptions.UnknownAnswerSetIdException();
        this.unknownAnswerSetIdException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.unknownUnauthenticatedUserSessionIdException = new UnauthenticatedUserSessionExceptions.UnknownUnauthenticatedUserSessionIdException();
        this.unknownUnauthenticatedUserSessionIdException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.rateLimitExceededException = new CoreApiExceptions.RateLimitExceededException();
        this.rateLimitExceededException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.serviceTemporarilyUnavailableException = new CoreApiExceptions.ServiceTemporarilyUnavailableException();
        this.serviceTemporarilyUnavailableException.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolService.BarProfitToolService_getReport_result.prototype.write = function(output) {
  output.writeStructBegin('BarProfitToolService_getReport_result');
  if (this.success !== null && this.success !== undefined) {
    output.writeFieldBegin('success', Thrift.Type.STRUCT, 0);
    this.success.write(output);
    output.writeFieldEnd();
  }
  if (this.unknownAnswerSetIdException !== null && this.unknownAnswerSetIdException !== undefined) {
    output.writeFieldBegin('unknownAnswerSetIdException', Thrift.Type.STRUCT, 1);
    this.unknownAnswerSetIdException.write(output);
    output.writeFieldEnd();
  }
  if (this.unknownUnauthenticatedUserSessionIdException !== null && this.unknownUnauthenticatedUserSessionIdException !== undefined) {
    output.writeFieldBegin('unknownUnauthenticatedUserSessionIdException', Thrift.Type.STRUCT, 2);
    this.unknownUnauthenticatedUserSessionIdException.write(output);
    output.writeFieldEnd();
  }
  if (this.rateLimitExceededException !== null && this.rateLimitExceededException !== undefined) {
    output.writeFieldBegin('rateLimitExceededException', Thrift.Type.STRUCT, 3);
    this.rateLimitExceededException.write(output);
    output.writeFieldEnd();
  }
  if (this.serviceTemporarilyUnavailableException !== null && this.serviceTemporarilyUnavailableException !== undefined) {
    output.writeFieldBegin('serviceTemporarilyUnavailableException', Thrift.Type.STRUCT, 4);
    this.serviceTemporarilyUnavailableException.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolService.BarProfitToolServiceClient = function(input, output) {
    this.input = input;
    this.output = (!output) ? input : output;
    this.seqid = 0;
};
BarProfitToolService.BarProfitToolServiceClient.prototype = {};
BarProfitToolService.BarProfitToolServiceClient.prototype.createFirstQuestionSet = function(unauthenticatedUserSessionId, callback) {
  var pendingError = new Error('Thrift Exception');
  this.send_createFirstQuestionSet(pendingError, unauthenticatedUserSessionId, callback); 
  if (!callback) {
    var result = null;
    try {
      result = this.recv_createFirstQuestionSet();
    } catch (e) {
      result = e;
      result.message = pendingError.message;
      result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      throw result;
    }
    return result;
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.send_createFirstQuestionSet = function(pendingError, unauthenticatedUserSessionId, callback) {
  this.output.writeMessageBegin('createFirstQuestionSet', Thrift.MessageType.CALL, this.seqid);
  var args = new BarProfitToolService.BarProfitToolService_createFirstQuestionSet_args();
  args.unauthenticatedUserSessionId = unauthenticatedUserSessionId;
  args.write(this.output);
  this.output.writeMessageEnd();
  if (callback) {
    var self = this;
    this.output.getTransport().flush(true, function(xhrError) {
      var result = null;
      try {
        result = self.recv_createFirstQuestionSet() || xhrError;
      } catch (e) {
        result = e;
        result.message = pendingError.message;
        result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      }
      callback(result);
    });
  } else {
    return this.output.getTransport().flush();
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.recv_createFirstQuestionSet = function() {
  var ret = this.input.readMessageBegin();
  var fname = ret.fname;
  var mtype = ret.mtype;
  var rseqid = ret.rseqid;
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(this.input);
    this.input.readMessageEnd();
    throw x;
  }
  var result = new BarProfitToolService.BarProfitToolService_createFirstQuestionSet_result();
  result.read(this.input);
  this.input.readMessageEnd();

  if (null !== result.unknownUnauthenticatedUserSessionIdException) {
    throw result.unknownUnauthenticatedUserSessionIdException;
  }
  if (null !== result.rateLimitExceededException) {
    throw result.rateLimitExceededException;
  }
  if (null !== result.serviceTemporarilyUnavailableException) {
    throw result.serviceTemporarilyUnavailableException;
  }
  if (null !== result.success) {
    return result.success;
  }
  throw 'createFirstQuestionSet failed: unknown result';
};
BarProfitToolService.BarProfitToolServiceClient.prototype.answerFirstQuestionSet = function(questionSetId, firstName, lastName, zipCode, phoneNumber, emailAddress, barName, barConnection, callback) {
  var pendingError = new Error('Thrift Exception');
  this.send_answerFirstQuestionSet(pendingError, questionSetId, firstName, lastName, zipCode, phoneNumber, emailAddress, barName, barConnection, callback); 
  if (!callback) {
    var result = null;
    try {
      result = this.recv_answerFirstQuestionSet();
    } catch (e) {
      result = e;
      result.message = pendingError.message;
      result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      throw result;
    }
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.send_answerFirstQuestionSet = function(pendingError, questionSetId, firstName, lastName, zipCode, phoneNumber, emailAddress, barName, barConnection, callback) {
  this.output.writeMessageBegin('answerFirstQuestionSet', Thrift.MessageType.CALL, this.seqid);
  var args = new BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_args();
  args.questionSetId = questionSetId;
  args.firstName = firstName;
  args.lastName = lastName;
  args.zipCode = zipCode;
  args.phoneNumber = phoneNumber;
  args.emailAddress = emailAddress;
  args.barName = barName;
  args.barConnection = barConnection;
  args.write(this.output);
  this.output.writeMessageEnd();
  if (callback) {
    var self = this;
    this.output.getTransport().flush(true, function(xhrError) {
      var result = null;
      try {
        result = self.recv_answerFirstQuestionSet() || xhrError;
      } catch (e) {
        result = e;
        result.message = pendingError.message;
        result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      }
      callback(result);
    });
  } else {
    return this.output.getTransport().flush();
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.recv_answerFirstQuestionSet = function() {
  var ret = this.input.readMessageBegin();
  var fname = ret.fname;
  var mtype = ret.mtype;
  var rseqid = ret.rseqid;
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(this.input);
    this.input.readMessageEnd();
    throw x;
  }
  var result = new BarProfitToolService.BarProfitToolService_answerFirstQuestionSet_result();
  result.read(this.input);
  this.input.readMessageEnd();

  if (null !== result.questionSetAlreadyAnsweredException) {
    throw result.questionSetAlreadyAnsweredException;
  }
  if (null !== result.unknownQuestionSetException) {
    throw result.unknownQuestionSetException;
  }
  if (null !== result.firstNameInvalidStringLengthException) {
    throw result.firstNameInvalidStringLengthException;
  }
  if (null !== result.lastNameInvalidStringLengthException) {
    throw result.lastNameInvalidStringLengthException;
  }
  if (null !== result.zipCodeInvalidStringLengthException) {
    throw result.zipCodeInvalidStringLengthException;
  }
  if (null !== result.phoneNumberInvalidStringLengthException) {
    throw result.phoneNumberInvalidStringLengthException;
  }
  if (null !== result.emailAddressInvalidStringLengthException) {
    throw result.emailAddressInvalidStringLengthException;
  }
  if (null !== result.barNameInvalidStringLengthException) {
    throw result.barNameInvalidStringLengthException;
  }
  if (null !== result.barConnectionInvalidStringLengthException) {
    throw result.barConnectionInvalidStringLengthException;
  }
  if (null !== result.rateLimitExceededException) {
    throw result.rateLimitExceededException;
  }
  if (null !== result.serviceTemporarilyUnavailableException) {
    throw result.serviceTemporarilyUnavailableException;
  }
  return;
};
BarProfitToolService.BarProfitToolServiceClient.prototype.createSecondQuestionSet = function(unauthenticatedUserSessionId, callback) {
  var pendingError = new Error('Thrift Exception');
  this.send_createSecondQuestionSet(pendingError, unauthenticatedUserSessionId, callback); 
  if (!callback) {
    var result = null;
    try {
      result = this.recv_createSecondQuestionSet();
    } catch (e) {
      result = e;
      result.message = pendingError.message;
      result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      throw result;
    }
    return result;
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.send_createSecondQuestionSet = function(pendingError, unauthenticatedUserSessionId, callback) {
  this.output.writeMessageBegin('createSecondQuestionSet', Thrift.MessageType.CALL, this.seqid);
  var args = new BarProfitToolService.BarProfitToolService_createSecondQuestionSet_args();
  args.unauthenticatedUserSessionId = unauthenticatedUserSessionId;
  args.write(this.output);
  this.output.writeMessageEnd();
  if (callback) {
    var self = this;
    this.output.getTransport().flush(true, function(xhrError) {
      var result = null;
      try {
        result = self.recv_createSecondQuestionSet() || xhrError;
      } catch (e) {
        result = e;
        result.message = pendingError.message;
        result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      }
      callback(result);
    });
  } else {
    return this.output.getTransport().flush();
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.recv_createSecondQuestionSet = function() {
  var ret = this.input.readMessageBegin();
  var fname = ret.fname;
  var mtype = ret.mtype;
  var rseqid = ret.rseqid;
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(this.input);
    this.input.readMessageEnd();
    throw x;
  }
  var result = new BarProfitToolService.BarProfitToolService_createSecondQuestionSet_result();
  result.read(this.input);
  this.input.readMessageEnd();

  if (null !== result.firstQuestionSetNotAnsweredException) {
    throw result.firstQuestionSetNotAnsweredException;
  }
  if (null !== result.unknownUnauthenticatedUserSessionIdException) {
    throw result.unknownUnauthenticatedUserSessionIdException;
  }
  if (null !== result.rateLimitExceededException) {
    throw result.rateLimitExceededException;
  }
  if (null !== result.serviceTemporarilyUnavailableException) {
    throw result.serviceTemporarilyUnavailableException;
  }
  if (null !== result.success) {
    return result.success;
  }
  throw 'createSecondQuestionSet failed: unknown result';
};
BarProfitToolService.BarProfitToolServiceClient.prototype.answerSecondQuestionSet = function(questionSetId, barProfitToolFormData, callback) {
  var pendingError = new Error('Thrift Exception');
  this.send_answerSecondQuestionSet(pendingError, questionSetId, barProfitToolFormData, callback); 
  if (!callback) {
    var result = null;
    try {
      result = this.recv_answerSecondQuestionSet();
    } catch (e) {
      result = e;
      result.message = pendingError.message;
      result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      throw result;
    }
    return result;
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.send_answerSecondQuestionSet = function(pendingError, questionSetId, barProfitToolFormData, callback) {
  this.output.writeMessageBegin('answerSecondQuestionSet', Thrift.MessageType.CALL, this.seqid);
  var args = new BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_args();
  args.questionSetId = questionSetId;
  args.barProfitToolFormData = barProfitToolFormData;
  args.write(this.output);
  this.output.writeMessageEnd();
  if (callback) {
    var self = this;
    this.output.getTransport().flush(true, function(xhrError) {
      var result = null;
      try {
        result = self.recv_answerSecondQuestionSet() || xhrError;
      } catch (e) {
        result = e;
        result.message = pendingError.message;
        result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      }
      callback(result);
    });
  } else {
    return this.output.getTransport().flush();
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.recv_answerSecondQuestionSet = function() {
  var ret = this.input.readMessageBegin();
  var fname = ret.fname;
  var mtype = ret.mtype;
  var rseqid = ret.rseqid;
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(this.input);
    this.input.readMessageEnd();
    throw x;
  }
  var result = new BarProfitToolService.BarProfitToolService_answerSecondQuestionSet_result();
  result.read(this.input);
  this.input.readMessageEnd();

  if (null !== result.questionSetAlreadyAnsweredException) {
    throw result.questionSetAlreadyAnsweredException;
  }
  if (null !== result.unknownQuestionSetException) {
    throw result.unknownQuestionSetException;
  }
  if (null !== result.invalidProductCategoryAndOrTotalValueException) {
    throw result.invalidProductCategoryAndOrTotalValueException;
  }
  if (null !== result.rateLimitExceededException) {
    throw result.rateLimitExceededException;
  }
  if (null !== result.serviceTemporarilyUnavailableException) {
    throw result.serviceTemporarilyUnavailableException;
  }
  if (null !== result.success) {
    return result.success;
  }
  throw 'answerSecondQuestionSet failed: unknown result';
};
BarProfitToolService.BarProfitToolServiceClient.prototype.getReport = function(unauthenticatedUserSessionId, secondAnswerSetId, callback) {
  var pendingError = new Error('Thrift Exception');
  this.send_getReport(pendingError, unauthenticatedUserSessionId, secondAnswerSetId, callback); 
  if (!callback) {
    var result = null;
    try {
      result = this.recv_getReport();
    } catch (e) {
      result = e;
      result.message = pendingError.message;
      result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      throw result;
    }
    return result;
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.send_getReport = function(pendingError, unauthenticatedUserSessionId, secondAnswerSetId, callback) {
  this.output.writeMessageBegin('getReport', Thrift.MessageType.CALL, this.seqid);
  var args = new BarProfitToolService.BarProfitToolService_getReport_args();
  args.unauthenticatedUserSessionId = unauthenticatedUserSessionId;
  args.secondAnswerSetId = secondAnswerSetId;
  args.write(this.output);
  this.output.writeMessageEnd();
  if (callback) {
    var self = this;
    this.output.getTransport().flush(true, function(xhrError) {
      var result = null;
      try {
        result = self.recv_getReport() || xhrError;
      } catch (e) {
        result = e;
        result.message = pendingError.message;
        result.stack = pendingError ? pendingError.stack || pendingError.stacktrace || pendingError : null;
      }
      callback(result);
    });
  } else {
    return this.output.getTransport().flush();
  }
};

BarProfitToolService.BarProfitToolServiceClient.prototype.recv_getReport = function() {
  var ret = this.input.readMessageBegin();
  var fname = ret.fname;
  var mtype = ret.mtype;
  var rseqid = ret.rseqid;
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(this.input);
    this.input.readMessageEnd();
    throw x;
  }
  var result = new BarProfitToolService.BarProfitToolService_getReport_result();
  result.read(this.input);
  this.input.readMessageEnd();

  if (null !== result.unknownAnswerSetIdException) {
    throw result.unknownAnswerSetIdException;
  }
  if (null !== result.unknownUnauthenticatedUserSessionIdException) {
    throw result.unknownUnauthenticatedUserSessionIdException;
  }
  if (null !== result.rateLimitExceededException) {
    throw result.rateLimitExceededException;
  }
  if (null !== result.serviceTemporarilyUnavailableException) {
    throw result.serviceTemporarilyUnavailableException;
  }
  if (null !== result.success) {
    return result.success;
  }
  throw 'getReport failed: unknown result';
};
